import {EntityLinkedToAccountWithAuditMetadata} from '../entity/entityLinkedToAccountWithAuditMetadata';
import {AccountSummaryConverter} from '../../account/common/api.converter/AccountSummary.converter';
import {EntityWithAuditMetadataConverter} from './entityWithAuditMetadata.converter';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class EntityLinkedToAccountWithAuditMetadataConverter {

    constructor(private entityWithAuditMetadataConverter: EntityWithAuditMetadataConverter) {
    }

    public convert <T extends EntityLinkedToAccountWithAuditMetadata>(target: T, entity: T): T {
        target.account = new AccountSummaryConverter().convert(entity.account);
        return this.entityWithAuditMetadataConverter.convert(target, entity);
    }
}
